import gql from 'graphql-tag';

export default gql`
query getPublishOfParentProject($projectId: Int!) {
  projects_by_pk(project_id: $projectId) {
    published
  }
}
`;
